import React from "react";
const BurgerIcon = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  width: "26px",
  height: "19px",
  viewBox: "0 0 26 19"
}, /*#__PURE__*/React.createElement("g", {
  id: "Hero-Sections",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-326.000000, -26.000000)",
  stroke: "currentColor",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(327.000000, 27.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0.8 L24,0.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,8.8 L24,8.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.6,16.8 L24,16.8"
})))));
export default BurgerIcon;
//# sourceMappingURL=BurgerIcon.js.map